'use strict';

const Reflux = require('@muzzylane/reflux');
const find = require('lodash/find');
const assign = require('lodash/assign');
const filter = require('lodash/filter');
const forEach = require('lodash/forEach');
const findIndex = require('lodash/findIndex');

const SubscriptionPlanActions = require('../actions/SubscriptionPlanActions');
const SignInActions = require('../actions/sign_in_actions');

const ForgeError = require('../util/error');
const ErrorConsts = require('../constants/error');
const Globals = require('../../../app/globals');

let plans = [];
let upgrade_plans = [];
let owned_org_subscriptions = [];
let action = {};
let error = null;
let loading = false;
let loading_upgrade_plans = false;
let subscription_plan = {};
let plan_prorate_data = {}; // details on what it costs to upgrade or downgrade to different stripe plans
let user_subscription_plan = {}; // subscription plan for a selected user (admin use)

const SubscriptionPlanStore = Reflux.createStore({
    listenables: [SubscriptionPlanActions,SignInActions],
    init: function() {return},

    resetState: function() {
        // action = {};
        // error = null;
        plans = [];         // full info for admins
        upgrade_plans = []; // subset of info for end user
        owned_org_subscriptions = [];
        loading = false;
        loading_upgrade_plans = false;
        subscription_plan = {}; // current user's subscription
        user_subscription_plan = {}; // some other user's subscription
    },

    onSignOutCompleted: function(res) {
        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        console.warn(err);
        this.resetState();
        this.emitStatus();
    },

    getState: function() {
        return {
            plans: plans,
            loading: loading,
            upgrade_plans: upgrade_plans,
            owned_org_subscriptions: owned_org_subscriptions,
            loading_upgrade_plans: loading_upgrade_plans,
            subscription_plan: subscription_plan,
            user_subscription_plan: user_subscription_plan,
            plan_prorate_data: plan_prorate_data,
            error: error,
            action: action
        }
    },

    emitStatus: function() {
        // console.log("activity store: EMIT");
        this.trigger(this.getState());
        action = {};
        //error = null;
    },

    onError: function(actionID, err) {
        action.id = actionID;

        if(err.status){
            // console.log("onError err:"  + JSON.stringify(err));
            switch(err.status){
                case 406:
                    action.error = new ForgeError({message: err.responseText, stack: null});
                    break;

                default:
                    action.error = new ForgeError({message: ErrorConsts.INTERNAL_GENERAL, stack: err.responseText || null});
            }
        }
        else {
            action.error = err;
        }

        this.emitStatus();
    },

    onCreatePlanCompleted: function(actionID, res, params) {
        // console.log("onCreatePlanCompleted: ", actionID, res);
        action = {};
        action.id = actionID;
        var existingPlan  = find(plans,{id: String(res.id)});
        if (!existingPlan) {
            // fill in some values that the create API doesn't provide
            var newPlan = assign({
                users: [],
                account_type: params.account_type,
            },res);
            plans = plans.concat(newPlan);
        }
        this.emitStatus();
    },

    onCreatePlanFailed: function(actionID, err) {
        console.warn("onCreatePlanFailed: ", actionID, err);
        action.id = actionID;
        //todo: parse err.status if required
        action.error = err;

        this.emitStatus();
    },

    onGetPlansStarted: function(actionID) {
        loading = true;
        this.emitStatus();
    },

    onGetPlansCompleted: function(actionID, planData) {
        action.id = actionID;
        plans = planData;
        loading = false;
//        console.log("onGetPlansCompleted, planData:");
//        if (planData) {
//            console.log(JSON.stringify(planData));
//        }

        this.emitStatus();
    },

    onGetPlansFailed: function(actionID, err) {
        console.warn("onGetPlansFailed: ", actionID, err);
        plans = [];
        loading = false;
        this.emitStatus();
        this.onError(actionID, err);
    },

    onArchivePlanCompleted: function(actionID, res) {
        // console.log("onArchivePlanCompleted: ", actionID, res);
        action = {};
        action.id = actionID;
        var plan_id = String(res.id);
        var existingPlan  = find(plans,{id: plan_id});
        if (!existingPlan) {
            console.log("error handling onArchivePlanCompleted");
            console.log("res: " + JSON.stringify(res));
            return;
        }
        plans = filter(plans,function(plan) {
            return plan.id !== plan_id;
        });
        this.emitStatus();
    },

    onArchivePlanFailed: function(actionID, err) {
        console.warn("onArchivePlanFailed: ", actionID, err);
        this.emitStatus();
        this.onError(actionID, err);
    },

    onGetUpgradePlansStarted: function(actionID) {
        loading_upgrade_plans = true;
        this.emitStatus();
    },

    onGetUpgradePlansCompleted: function(actionID, planData) {
        action.id = actionID;
        upgrade_plans = planData;
        loading_upgrade_plans = false;
        this.emitStatus();
    },

    onGetUpgradePlansFailed: function(actionID, err) {
        console.warn("onGetUpgradePlansFailed: ", actionID, err);
        upgrade_plans = [];
        loading_upgrade_plans = false;
        this.emitStatus();
        this.onError(actionID, err);
    },

    onGetSubscriptionPlanCompleted: function(actionID, planData) {
        action.id = actionID;
        subscription_plan = planData;
        this.emitStatus();
    },

    onGetSubscriptionPlanFailed: function(actionID, err) {
        console.warn("onGetSubscriptionPlanFailed: ", actionID, err);
        subscription_plan = {}
        this.emitStatus();
        this.onError(actionID, err);
    },

    onGetSubscriptionPlanForUserCompleted: function(actionID, planData) {
        action.id = actionID;
        user_subscription_plan = planData;
        this.emitStatus();
    },

    onGetSubscriptionPlanForUserFailed: function(actionID, err) {
        console.warn("onGetSubscriptionPlanForUserFailed: ", actionID, err);
        user_subscription_plan = {}
        this.emitStatus();
        this.onError(actionID, err);
    },

    onGetOwnedOrgSubscriptionsCompleted: function(actionID, data) {
        action.id = actionID;
        owned_org_subscriptions = data;
        this.emitStatus();
    },

    onGetOwnedOrgSubscriptionsFailed: function(actionID, err) {
        console.warn("onGetSubscriptionPlanFailed: ", actionID, err);
        owned_org_subscriptions = []
        this.emitStatus();
        this.onError(actionID, err);
    },

    onChangePurchaseOrderPlanCompleted: function(actionID, res, params) {
        // change plan users
        var newPlans = plans.slice();
        var changed = false;
        forEach(newPlans,function(plan) {
            if (params.plan_id === plan.id) {
                // user_id should be in users
                if (plan.users) {
                    let i = findIndex(plan.users,{user_id:params.user_id});
                    if (i < 0) {
                        plan.users = plan.users.concat({
                            user_id: params.user_id,
                            // other user info?
                        });
                    }
                }
                else {
                    plan.users = [{
                        user_id: params.user_id,
                        // other user info?
                    }];
                }
            }
            else {
                let i = findIndex(plan.users,{user_id: params.user_id});
                if (i >= 0) {
                    plan.users = plan.users.slice();
                    plan.users.splice(i,1);
                }
            }
        });
        plans = newPlans;
        action.id = actionID;
        this.emitStatus();
    },

    onChangePurchaseOrderPlanFailed: function(actionID, err) {
        console.warn("onChangePurchaseOrderPlanFailed: ", actionID, err);
        this.emitStatus();
        this.onError(actionID, err);
    },

    onGetProrateDataCompleted: function(actionID, data) {
        action.id = actionID;
        plan_prorate_data = data;
        this.emitStatus();
    },

    onGetProrateDataFailed: function(actionID, err) {
        console.warn("onGetProrateDataFailed: ", actionID, err);
        plan_prorate_data = {}
        this.emitStatus();
        this.onError(actionID, err);
    },

    onChangeSubscriptionPlanCompleted: function(actionId, planData) {
        console.log('onChangeSubscriptionPlanCompleted:', actionId, planData);
        action = { id: actionId };
        if (planData.sessionId) {
            // new stripe flow for embedded mode
            // put it in the action for the react component to do the embedding.
            action.sessionId = planData.sessionId;
        }
        else if (planData.sessionUrl) {
            // new stripe flow for hosted mode
            // put it in the action for the react component to do the redirecting.
            action.sessionUrl = planData.sessionUrl; // hosted mode
        }
        else {
            subscription_plan = planData;
        }
        
        this.emitStatus();
    },

    onChangeSubscriptionPlanFailed: function(actionId, err) {
        console.log('onChangeSubscriptionPlanFailed:', actionId, err);
        action = { id: actionId, err: err };
        this.emitStatus();
    },

    onChangeSubscriptionStatusCompleted: function(actionId, res, params) {
        action = { id: actionId };
        if (user_subscription_plan && user_subscription_plan.subscription) {
            if (params.user_id === user_subscription_plan.subscription.user_id) {
                user_subscription_plan.subscription.status = user_subscription_plan.plan.subscription_status = params.status;
            }
        }
        this.emitStatus();
    },

    onChangeSubscriptionStatusFailed: function(actionId, err) {
        console.log('onChangeSubscriptionStatusFailed:', actionId, err);
        action = { id: actionId, err: err };
        this.emitStatus();
    },

    onCancelSubscriptionCompleted: function(actionId, planData) {
        console.log('onCancelSubscriptionCompleted:', actionId, planData);
        action = { id: actionId };
        subscription_plan = planData;
        this.emitStatus();
    },

    onCancelSubscriptionFailed: function(actionId, err) {
        console.log('onChangeSubscriptionFailed:', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    }


});

module.exports = SubscriptionPlanStore;
